import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import { SubTrendingSkeleton } from './Trending';

const DynamicSubTrending = dynamic(() => import('./Trending'), {
  ssr: false,
  loading: () => <SubTrendingSkeleton />
});

const Trending = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <SubTrendingSkeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicSubTrending skeleton={skeleton} {...props} />;
};

export default Trending;
